import { createSlice } from "@reduxjs/toolkit";
import { fetchAllIndustryData, fetchAllMasterData } from "./candidateSlice";

const masterDataSlice = createSlice({
  name: "masterData",
  initialState: {
    skillsOptions: [],
    languageOptions: [],
    expertiseOptions: [],
    industryOptions: [],
    keywordOptions: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllMasterData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllMasterData.fulfilled, (state, action) => {
        state.loading = false;
        state.keywordOptions = action.payload.data
          .filter((item) => item.mastertype === "keyword")
          .map((item) => ({ value: item._id.$oid, label: item.mastervalue }));
        state.skillsOptions = action.payload.data
          .filter((item) => item.mastertype === "skill")
          .map((item) => ({ value: item._id.$oid, label: item.mastervalue }));
        state.expertiseOptions = action.payload.data
          .filter((item) => item.mastertype === "Expertise")
          .map((item) => ({ value: item._id.$oid, label: item.mastervalue }));
        state.languageOptions = action.payload.data
          .filter((item) => item.mastertype === "language")
          .map((item) => ({ value: item._id.$oid, label: item.mastervalue }))
          .sort((a, b) => {
            if (a.label === "English") return -1;
            if (b.label === "English") return 1;
            return a.label.localeCompare(b.label);
          });
      })
      .addCase(fetchAllMasterData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAllIndustryData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllIndustryData.fulfilled, (state, action) => {
        state.loading = false;
        state.industryOptions = action.payload.data.map((item) => ({
          value: item._id.$oid,
          label: item.label,
        }));
      })
      .addCase(fetchAllIndustryData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default masterDataSlice.reducer;
